import { render } from "./pet.vue?vue&type=template&id=5bd38225&scoped=true"
import script from "./pet.vue?vue&type=script&lang=js"
export * from "./pet.vue?vue&type=script&lang=js"

import "./pet.vue?vue&type=style&index=0&id=5bd38225&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd38225"]])

export default __exports__